module.exports = __webpack_public_path__ + "img/captain.1810a1d1.jpeg";